module.exports = __webpack_public_path__ + "img/complete-forms.7d781075.svg";